import { Link } from "react-router-dom";
import { useSettings } from "@/lib/useSettings";
import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";

export default function Hero({ onOpenQuote }) {
  const { settings } = useSettings();
  const s = settings || {};

  return (
    <section className="aman-hero relative min-h-[92vh] md:min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="aman-scanline" aria-hidden="true" />
      <div className="aman-glow-orb -top-32 -end-32" aria-hidden="true" />
      <div className="aman-glow-orb hidden md:block -bottom-40 -start-24 opacity-70" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Text side */}
        <div className="lg:col-span-7 text-slate-100 text-start">
          <Reveal>
            <span className="aman-tag" data-testid="hero-tag">
              <span className="w-2 h-2 rounded-full bg-[#00E5FF] shadow-[0_0_10px_#00E5FF]" />
              شركة رائدة في الأنظمة الأمنية — فلسطين
            </span>
          </Reveal>
          <Reveal delay={120}>
            <h1 className="font-heading mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.15] tracking-tight text-white" data-testid="hero-headline">
              {s.hero_headline_ar || "حماية استثنائية لمنشآتك بتقنيات الجيل الجديد"}
            </h1>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-6 text-lg text-slate-300 max-w-xl leading-relaxed" data-testid="hero-sub">
              {s.hero_subheadline_ar}
            </p>
          </Reveal>
          <Reveal delay={360}>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <button
                onClick={onOpenQuote}
                className="aman-btn-primary text-base"
                data-testid="hero-cta-quote"
              >
                <Icon name="send" size={18} strokeWidth={2} />
                اطلب عرض سعر
              </button>
              {s.phone && (
                <a
                  href={`tel:${s.phone}`}
                  className="aman-btn-secondary text-base"
                  data-testid="hero-cta-call"
                >
                  <Icon name="phone" size={18} />
                  اتصل بنا الآن
                </a>
              )}
            </div>
          </Reveal>

          {/* small trust row */}
          <Reveal delay={520}>
            <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-slate-400 text-sm">
              <div className="flex items-center gap-2"><Icon name="check-circle" size={16} className="text-[#00E5FF]" /> تركيب احترافي معتمد</div>
              <div className="flex items-center gap-2"><Icon name="check-circle" size={16} className="text-[#00E5FF]" /> ضمان شامل سنتين</div>
              <div className="flex items-center gap-2"><Icon name="check-circle" size={16} className="text-[#00E5FF]" /> دعم فني 24/7</div>
            </div>
          </Reveal>
        </div>

        {/* Visual side */}
        <div className="lg:col-span-5 hidden lg:block">
          <Reveal delay={200}>
            <div className="relative">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-[#00E5FF]/20 to-transparent blur-2xl" aria-hidden="true" />
              <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_30px_80px_-30px_rgba(0,229,255,0.35)]">
                <img
                  src={s.hero_image || "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?auto=format&fit=crop&w=1200&q=80"}
                  alt="أمان — منظومات حماية متقدمة"
                  className="w-full h-[520px] object-cover"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#0A1628]/70 via-transparent to-transparent" />
                <div className="absolute bottom-6 start-6 end-6 flex items-center gap-3 bg-black/40 backdrop-blur-md rounded-2xl border border-white/10 px-4 py-3">
                  <div className="w-10 h-10 rounded-xl bg-[#00E5FF]/20 border border-[#00E5FF]/40 flex items-center justify-center">
                    <Icon name="shield-check" className="text-[#00E5FF]" size={20} />
                  </div>
                  <div className="text-white/90">
                    <div className="font-heading font-bold">حماية ذكية 24/7</div>
                    <div className="text-xs text-slate-300">مراقبة مباشرة من هاتفك</div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
